import * as React from "react";
import {AbholungListStatistics} from './abholungen';
import {ClearFloat, date2DateString, date2DateTimeString, date2WeekdayDateString, GetAbfallart, InlineLoading} from "./index";
import {useGetList} from 'react-admin';

import {
	Grid,
	Paper,
	Typography,
	Button,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody
} from '@mui/material';

import {People, Phone, Http, LocalShipping} from "@mui/icons-material";
import {themeStyles} from "./index";

let abholtermineProps = {
	basePath: "/abholtermine",
	hasCreate: false,
	hasEdit: false,
	hasList: true,
	hasShow: false,
	history: {},
	location: {pathname: "/", search: "", hash: "", state: undefined},
	match: {path: "/", url: "/", isExact: true, params: {}},
	options: {},
	permissions: null,
	resource: "abholtermine"
}

const GetAnmeldungenToday = (key) => {
	const webServiceAccount = 'service-account-sperrmuell-rheingau-taunus.de';
	var returnKey = Object.values(key).join('');

	const {total, data, isLoading, error} = useGetList(
'anmeldungen',
{
			pagination: {
				page: 1,
				perPage: 9999
			},
			sort: {field: 'ort', order: 'DESC'},
			filter: {inserted: (new Date()).toISOString().split('T')[0]}
		}
	);

	if (isLoading) return <InlineLoading/>;
	if (error) return null;
	if (!data) return null;

	switch (returnKey) {
		case 'total':
			return (
				<span>{total}</span>
			)
		case 'web':
			var anzahlWeb = 0;
			{data.map(anmeldung => (anmeldung.insertedBy === webServiceAccount ? anzahlWeb+=1 : null))}
			return (
				<span>{anzahlWeb}</span>
			)
		case 'phone':
			var anzahlPhone = 0;
			{data.map(anmeldung => (anmeldung.insertedBy !== webServiceAccount ? anzahlPhone+=1 : null))}
			return (
				<span>{anzahlPhone}</span>
			)
		case 'menge':
			var summeMenge = 0;
			{data.map(anmeldung => summeMenge+=anmeldung.menge)}
			return (
				<span>{summeMenge}</span>
			)
		default:
			return null;
	}
};

const DashboardStatistics = () => {
	var keyTotal = 'total';
	var keyPhone = 'phone';
	var keyWeb   = 'web';
	var keyMenge = 'menge';

	return (
		<Paper elevation={0} sx={{background: 'none'}}>
			<Grid container spacing={2}>
				<Grid item xs={3}>
					<Paper elevation={2} sx={{
						p: 2,
						background: '#fff',
						color: '#222',
						textAlign: 'left',
						marginBottom: '20px'
					}}>
						<Typography variant={"h4"}>
							<GetAnmeldungenToday {...keyTotal}/>
							<People sx={{fontSize: '40px', color: '#B83BA1', float: 'right'}}/>

						</Typography>
						<Typography variant={"caption"}>
							neue Anmeldungen heute
						</Typography>
					</Paper>
				</Grid>
				<Grid item xs={3}>
					<Paper elevation={2} sx={{
						p: 2,
						background: '#fff',
						color: '#222',
						textAlign: 'left',
						marginBottom: '20px'
					}}>
						<Typography variant={"h4"}>
							<GetAnmeldungenToday {...keyPhone}/>
							<Phone sx={{fontSize: '40px', color: '#C379B6', float: 'right'}}/>
						</Typography>
						<Typography variant={"caption"}>
							per Telefon
						</Typography>
					</Paper>
				</Grid>
				<Grid item xs={3}>
					<Paper elevation={2} sx={{
						p: 2,
						background: '#fff',
						color: '#222',
						textAlign: 'left',
						marginBottom: '20px'
					}}>
						<Typography variant={"h4"}>
							<GetAnmeldungenToday {...keyWeb}/>
							<Http sx={{fontSize: '40px', color: '#C379B6', float: 'right'}}/>
						</Typography>
						<Typography variant={"caption"}>
							per Internet
						</Typography>
					</Paper>
				</Grid>
				<Grid item xs={3}>
					<Paper elevation={2} sx={{
						p: 2,
						background: '#fff',
						color: '#222',
						textAlign: 'left',
						marginBottom: '20px'
					}}>
						<Typography variant={"h4"}>
							<GetAnmeldungenToday {...keyMenge}/> m³
							<LocalShipping sx={{fontSize: '40px', color: '#2872b7', float: 'right'}}/>
						</Typography>
						<Typography variant={"caption"}>
							neue Anmeldungen heute
						</Typography>
					</Paper>
				</Grid>
			</Grid>
		</Paper>
	)
}

const NeuesteAnmeldungen = () => {
	const {total, data, isLoading, error} = useGetList(
		'anmeldungen',
		{
			pagination: {page: 1, perPage: 10},
			sort: {field: 'inserted', order: 'DESC'}
		}
	);

	if (isLoading) return <InlineLoading/>;
	if (error) return null;
	if (!data) return null;

	return (
		<TableContainer component={Paper} elevation={3}>
			<Table sx={{minWidth: 650}} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell>Name</TableCell>
						<TableCell>Straße</TableCell>
						<TableCell>Ort</TableCell>
						<TableCell>Abfallart</TableCell>
						<TableCell>Termin</TableCell>
						<TableCell align="right">Menge</TableCell>
						<TableCell>Anmerkungen</TableCell>
						<TableCell>Anmeldedatum</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{data.map(row =>
						<TableRow
							key={row.id}
							sx={{'&:last-child td, &:last-child th': {border: 0}}}
						>
							<TableCell component="th" scope="row">{row.vorname} {row.nachname}</TableCell>
							<TableCell>{row.strasse} {row.hausnummer}</TableCell>
							<TableCell>{row.plz} {row.ort}</TableCell>
							<TableCell><GetAbfallart {...row}/></TableCell>
							<TableCell>{date2DateString(row.termin)}</TableCell>
							<TableCell align="right">{row.menge}</TableCell>
							<TableCell>{row.anmerkungen}</TableCell>
							<TableCell>{date2DateTimeString(row.inserted)}</TableCell>
						</TableRow>
					)}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

const DashboardAnmeldungen = () => {
	const themeStyle = themeStyles();
	return (
		<Paper elevation={2}
			   sx={{padding: '20px', marginTop: '30px'}}>
			<Grid container spacing={2} sx={{marginBottom: '20px'}}>
				<Grid item xs={1}>
					<Paper elevation={10} className={themeStyle.anmeldung_bg} sx={{
						p: 2,
						color: '#fff',
						textAlign: 'center',
						width: '60px',
						height: '60px',
						marginTop: '-30px'
					}}>
						<People sx={{fontSize: '58px'}}/>
					</Paper>
				</Grid>
				<Grid item xs={11}>
					<Typography variant={"h5"}>
						Neueste Anmeldungen
					</Typography>
				</Grid>
			</Grid>
			<NeuesteAnmeldungen/>
			<Button href="/#/anmeldungen" variant="contained" className={themeStyle.anmeldung_bg} sx={{marginTop: '20px', float: 'right'}}>Alle Anmeldungen</Button>
			<ClearFloat/>
		</Paper>
	)
}

const NaechsteAbholungen = () => {
	const {total, data, isLoading, error} = useGetList(
		'abholtermine',
		{
			pagination: {page: 1, perPage: 10},
			sort: {field: 'abholdatum', order: 'ASC'},
			filter: {abholdatum: {after: (new Date()).toISOString().split('T')[0]}}
		}
	);

	if (isLoading) return <InlineLoading/>;
	if (error) return null;
	if (!data) return null;

	return (
		<TableContainer component={Paper} elevation={3}>
			<Table sx={{minWidth: 650}} aria-label="simple table">
				<TableHead>
					<TableRow>
						<TableCell>Abholdatum</TableCell>
						<TableCell>Abholgebiet</TableCell>
						<TableCell>Abfallart</TableCell>
						<TableCell align="right">Anzahl</TableCell>
						<TableCell align="right">Ist</TableCell>
						<TableCell align="right">Max</TableCell>
						{/*<TableCell>Auslastung</TableCell>*/}
					</TableRow>
				</TableHead>
				<TableBody>
					{data.map(row =>
						<TableRow
							key={row.id}
							sx={{'&:last-child td, &:last-child th': {border: 0}}}
						>
							<TableCell component="th" scope="row" sx={{whiteSpace: 'nowrap'}}>{date2WeekdayDateString(row.abholdatum)}</TableCell>
							<TableCell>{row.abholgebiet.beschreibung}</TableCell>
							<TableCell>{row.abfallart.name}</TableCell>
							<TableCell align="right">{row.anzahl_ist}</TableCell>
							<TableCell align="right">{row.menge_ist}</TableCell>
							<TableCell align="right">{row.menge_max}</TableCell>
							{/*<TableCell><AbholungListStatistics label={"Auslastung"}/></TableCell>*/}
						</TableRow>
					)}
				</TableBody>
			</Table>
		</TableContainer>
	)
};

//todo: consider Landkreis
//todo: Filter abholgebiet entfernen
const DashboardAbholungen = () => {
	const themeStyle = themeStyles();
	return (
		<Paper elevation={2}
			   sx={{padding: '20px', marginTop: '30px'}}>
			<Grid container spacing={2} sx={{marginBottom: '20px'}}>
				<Grid item xs={1}>
					<Paper elevation={10} className={themeStyle.abholung_bg} sx={{
						p: 2,
						color: '#fff',
						textAlign: 'center',
						width: '60px',
						height: '60px',
						marginTop: '-30px'
					}}>
						<LocalShipping sx={{fontSize: '58px'}}/>
					</Paper>
				</Grid>
				<Grid item xs={11}>
					<Typography variant={"h5"}>
						Nächste Abholungen
					</Typography>
				</Grid>
			</Grid>
			<NaechsteAbholungen/>
			<Button href="/#/abholtermine" variant="contained" className={themeStyle.abholung_bg} sx={{marginTop: '20px', float: 'right'}}>Alle Abholungen</Button>
			<ClearFloat/>
		</Paper>
	)
}

export default () => (
	<div>
		<DashboardStatistics/>
		<DashboardAnmeldungen/>
		<DashboardAbholungen/>
	</div>
)

export {DashboardAnmeldungen};